<template>
	<div class="wrapper">
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md3>
					<v-select
						persistent-hint
						hint="Select File Extension"
						color="yellow darken-3"
						:items="fileExtensions"
						label="File Extensions"
						v-model="extension"
					></v-select>
				</v-flex>
				<v-flex xs12 sm12 md5>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs6 sm6 md3>
					<v-btn @click="filterFiles" flat color="orange darken-1" large
						>Filter</v-btn
					>
				</v-flex>
				<v-flex xs6 sm6 md3 @click="refreshList">
					<v-btn color="pink" flat>Reset Filter</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<code>No. of files: {{ getFileCount }}</code>
		<v-expansion-panel>
			<v-expansion-panel-content
				v-for="item of Object.keys(files)"
				:key="item"
			>
				<template v-slot:header>
					<div class="font-weight-light pa-2">
						<span class="headline">
							Stockist Name: -
							{{ files[item][0] ? files[item][0].stockistName : '' }}
						</span>
						<br />
						<span class="subheader">Stockist Code: - {{ item }}</span>
						<br />
						<span class="subheader">Files: - {{ files[item].length }}</span>
					</div>
				</template>
				<v-card flat>
					<v-card-text>
						<v-list three-line subheader>
							<v-list-tile
								v-for="(file, i) in files[item]"
								:key="file._id"
								@click="openFileMetaModal(file)"
							>
								<v-list-tile-action>
									<v-icon>attach_file</v-icon>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title>
										{{ i + 1 }}. Filename: - {{ file.filename }}
									</v-list-tile-title>
									<v-list-tile-sub-title>
										Original file name: - {{ file.originalFilename }}
									</v-list-tile-sub-title>
									<v-list-tile-sub-title>
										Date: - {{ getFormattedDate(file.date) }}
										<span v-if="'subject' in file && file.subject">
											| Sub: - {{ file.subject }}
										</span>
									</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon>keyboard_arrow_right</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div class="mt-1 mb-1 text-xs-center">
			<v-pagination
				color="yellow darken-3"
				prev-icon="navigate_before"
				next-icon="navigate_next"
				v-model="page"
				:total-visible="5"
				:length="paginationLength"
				@input="updatePage"
			></v-pagination>
		</div>
		<v-btn
			@click="refreshList"
			color="pink"
			fab
			dark
			fixed
			small
			bottom
			right
		>
			<v-icon>autorenew</v-icon>
		</v-btn>
		<FileMetaModal v-if="fileMetaEditorDialog" />
	</div>
</template>

<script>
import FileMetaModal from './fileMetaModal';
import moment from 'moment-timezone';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			page: 1,
			paginationLength: 10,
			filterText: '',
			extension: false,
			fileExtensions: [
				{ text: 'All', value: false },
				...require('../../components/extensions.json'),
			],
		};
	},
	components: {
		FileMetaModal,
	},
	created() {
		this.fetchFiles();
	},
	methods: {
		...mapActions('aiMetaMap', ['getFiles']),
		...mapMutations('aiMetaMap', ['openFileMetaDialog', 'setSelectedFile']),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog', 'openSnackbar']),
		openFileMetaModal(item) {
			this.setSelectedFile(item);
			this.openFileMetaDialog();
		},
		fetchFiles() {
			this.openLoaderDialog();
			let params = {
				pageNo: this.page,
				pageSize: 20,
				...this.getSelectedDates,
			};
			if (this.filterText) {
				params.text = this.filterText;
			}
			if (this.extension) {
				params.extension = this.extension;
			}
			this.getFiles(params).then(data => {
				this.closeLoaderDialog();
				if (data) {
					this.paginationLength = Math.ceil(data.length / 20);
				} else {
					console.log('Failed to load AI Meta Map files');
				}
			});
		},
		refreshList() {
			this.page = 1;
			this.filterText = '';
			this.extension = false;
			this.fetchFiles();
		},
		updatePage() {
			this.fetchFiles();
		},
		filterFiles() {
			this.page = 1;
			this.fetchFiles();
		},
		getFormattedDate(date) {
			return moment(date)
				.tz('Asia/Kolkata')
				.format('DD-MMM-YYYY');
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates']),
		...mapGetters('aiMetaMap', ['fileMetaEditorDialog', 'files']),
		getFileCount() {
			let count = 0;
			for (let i in this.files) {
				count += this.files[i].length;
			}
			return count;
		},
	},
	mounted() {
		this.$store.subscribe(mutation => {
			if (mutation.type === 'aiMetaMap/refreshListEmitter') {
				this.refreshList();
			}
		});
	},
	watch: {
		selectedDates() {
			this.refreshList();
		},
	},
};
</script>

<style lang="scss" scoped>
.v-pagination >>> li button {
	width: 100%;
	min-width: 35px;
}
.v-card__text {
	padding: 0px;
}
</style>
